// extracted by mini-css-extract-plugin
module.exports = {"container":"za","copy":"Aa","field":"Ba","error":"Ca","disabled":"Da","termsContainer":"Ea","termsHeading":"Fa","termsCopy":"Ga","submit":"Ha","srOnly":"Ia"};